import React from 'react';
import { Link } from 'react-router-dom';

interface FooterProps {
  className?: string;
}

export default function Footer({ className = '' }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-6 mt-auto ${className}`}>
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-sm text-gray-500 dark:text-gray-400">
          <div className="flex items-center space-x-1">
            <span>Powered by</span>
            <span className="font-semibold text-gray-900 dark:text-white">CourtSync</span>
          </div>

          <div className="flex items-center space-x-6">
            <Link to="/terms" className="hover:text-gray-900 dark:hover:text-white transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="hover:text-gray-900 dark:hover:text-white transition-colors">
              Privacy Policy
            </Link>
          </div>

          <div>
            &copy; {currentYear} CourtSync
          </div>
        </div>
      </div>
    </footer>
  );
}
